import { featureEnabled } from "byzantine/src/Feature";
import type { Features } from "byzantine/src/Feature";

export type AchImportDefaultAction = "send" | "collect";

export const getAchImportPermittedActions = (
  features: Features
): AchImportDefaultAction[] => {
  const actions: AchImportDefaultAction[] = [];

  if (
    featureEnabled(features, { or: "indigo.ACHPaymentViaImport_permission" })
  ) {
    actions.push("send");
  }

  if (
    featureEnabled(features, {
      or: "indigo.ACHPaymentCollectViaImport_permission",
    })
  ) {
    actions.push("collect");
  }

  return actions;
};

export const getAchImportDefaultAction = (
  features: Features
): AchImportDefaultAction => {
  const permitted = getAchImportPermittedActions(features);

  return permitted.includes("collect") && !permitted.includes("send")
    ? "collect"
    : "send";
};
